import { render } from "./QueryButton.vue?vue&type=template&id=5ec2a3b3&scoped=true"
import script from "./QueryButton.vue?vue&type=script&lang=js"
export * from "./QueryButton.vue?vue&type=script&lang=js"

import "./QueryButton.vue?vue&type=style&index=0&id=5ec2a3b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec2a3b3"]])

export default __exports__